module.exports = __webpack_public_path__ + "img/logo.a96f5dd1.svg";